// extracted by mini-css-extract-plugin
export default {"status":"Status-module__status__S36ib","icon":"Status-module__icon__ekJiF","invalid":"Status-module__invalid__g9dwv","valid":"Status-module__valid__erW2G"};